export const resolveProgressString = (progressMs) => {
  const totalSeconds = Math.floor(progressMs / 1e3);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
};
export const resolveImageUrl = (images) => [...images].sort((a, b) => (a.width ?? 0) - (b.width ?? 0)).shift()?.url;
